export default "__VITE_ASSET__C1BKxE$UaMwTRDHTKiTBoA__";